import React, {useState, useEffect} from 'react';
import ModalUsados from '../Modals/ModalUsados';
import useFinanciadoData from '../../hooks/useFinanciadoData';
import { CurrencyFormat } from '../../../utils';

const UsadosSelector = () => {
    const { getUsado, resetUsado } = useFinanciadoData();
    const usado = getUsado();
    
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [])

    const handleModalUsados = () => {
        setIsOpen(true);
    }

    const handleOmitUsados = () => {
        resetUsado();
    }

    return (
        <div className="usado-selector">
            <div className="component-header">
                <h2>Simula Precio de toma de tu usado</h2>
                <div className="component-subtitle">Si quieres entregar tu vehículo usado, ¡simúlalo ahora!</div>
            </div>
            <div className="component-body">
                <div className={"item-box inicio-toma-usado " + (usado.range ? "active" : "")} onClick={() => handleModalUsados()}>
                    {usado.details ? 
                    <>
                        <span>Tu usado en forma de pago <small>Editar <i className="icon chevron-strong"></i></small></span>
                        <div className="usado-details">
                            <p>{usado.details.make} {usado.selectedVersion.name}</p>
                            <ul>
                                <li>Año {usado.details.year}</li>
                                <li>{usado.mileage.name}</li>
                                <li className="red-text">{CurrencyFormat(usado.range.min)} a {CurrencyFormat(usado.range.max)}</li>
                            </ul>
                        </div>
                    </>
                    : 
                    <span>Estima el valor Referencial de tu usado</span>
                    }
                </div>
                <div className={"item-box " + (usado.range ? "" : "active")} onClick={() => handleOmitUsados()}>
                    <span>Omitir por ahora</span>
                </div>
            </div>
            <ModalUsados isOpen={isOpen} onCloseModal={() => setIsOpen(false)}/>
        </div>
    )
}

export default UsadosSelector;